import { Col1, Col2, Col3, Col4 } from '..';
import { Container, Row } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useRef } from 'react';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { telephonicServices } from 'src/services';
import { typeCallingState, typeHousehold, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    household: typeHousehold;
    setAddressToShowInGoogleMaps: Dispatch<SetStateAction<string>>;
    territoryNumber: typeTerritoryNumber;
};

export const TelephonicCard: FC<propsType> = ({ household, setAddressToShowInGoogleMaps, territoryNumber }) => {
    const dispatch = useDispatch();
    const householdCard = useRef<any>(null);
    const isDarkMode = useGetIsDarkMode();

    const modifyHouseholdHandler = async (householdId: number, callingState: typeCallingState, notSubscribed: boolean, isAssigned: boolean | undefined): Promise<void> => {
        dispatch(showLoadingModalReducer());
        const response = await telephonicServices.ModifyHousehold(territoryNumber, householdId, callingState, notSubscribed, !!isAssigned);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
        }
    }

    return (
        <div key={household.id}
            className={`card ${household.isAssigned ? 'bg-grey bg-opacity bg-gradient' : isDarkMode ? 'bg-dark text-white' : ''} animate__animated animate__bounceInLeft animate__faster`}
            style={{
                border: '1px solid gray',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                marginBottom: '50px'
            }}
            ref={householdCard}
        >   
            <Container fluid={'lg'}>
                <Row style={{ margin: '0 25px', paddingBottom: '12px', paddingTop: '15px' }}>
                    <Col1
                        household={household}
                        setAddressToShowInGoogleMaps={setAddressToShowInGoogleMaps}
                        territoryNumber={territoryNumber}
                    />
                    <Col2
                        household={household}
                        card={householdCard}
                    />
                    <Col3
                        household={household}
                        modifyHouseholdHandler={modifyHouseholdHandler}
                    />
                    <Col4
                        household={household}
                        modifyHouseholdHandler={modifyHouseholdHandler}
                    />
                </Row>
            </Container>
        </div>
    );
}
